import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { NotFoundPage } from "@pages/not-found";

import { JwtInterceptor, ErrorInterceptor } from "./helpers/index";

import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import {
  NavigationEffects,
  sidebarReducer,
  userReducer,
  navigationReducer,
  languageReducer,
  LanguageEffects,
  BannerEffects,
  bannerReducer,
  CampaignEffects,
  campaingReducer,
  pageReducer,
  paymentReducer,
  PaymentEffects,
  AffiliateEffects,
  affiliateReducer,
  commissionGroupReducer,
  CommissionGroupEffects,
  countryReducer,
  CountryEffects,
  UserEffects,
  campaignAffiliateReducer,
  CampaignAffiliatesEffects,
  downlineReducer,
  DownlinesEffects,
  PaymentMethodEffects,
  paymentMethodReducer,
  PageEffects,
  ChannelEffects,
  channelReducer,
  DashboardEffects,
  dashboardReducer,
  configReducer,
  ConfigEffects,
  TopListingEffects,
  topListingsReducer,
  affiliateManagersReducer,
  AffiliateManagerssEffects,
  ReportEffects,
  reportReducer,
  messageReducer,
  MessagesEffects,
  campaignUrlsReducers,
  CampaignUrlsEffects,
  notificationsReducer,
  NotificationsEffects,
  categoryReducer,
  CategoryEffects,
} from "@store/index";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "../environments/environment";
import { NotificationModule } from "@components/index";
import { EventCategoryEffects, eventCategoryReducer } from "@store/event-category";

@NgModule({
  declarations: [AppComponent, NotFoundPage],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NotificationModule,
    
    StoreModule.forRoot({
      sidebar: sidebarReducer,
      user: userReducer,
      language: languageReducer,
      navigation: navigationReducer,
      banner: bannerReducer,
      campaign: campaingReducer,
      page: pageReducer,
      payment: paymentReducer,
      commissionGroup: commissionGroupReducer,
      affiliate: affiliateReducer,
      country: countryReducer,
      campaignAffiliate: campaignAffiliateReducer,
      downline: downlineReducer,
      paymentMethods: paymentMethodReducer,
      channel: channelReducer,
      dashboard: dashboardReducer,
      config: configReducer,
      topListing: topListingsReducer,
      affiliateManagers: affiliateManagersReducer,
      report: reportReducer,
      message: messageReducer,
      campaignUrls: campaignUrlsReducers,
      notifications: notificationsReducer,
      category: categoryReducer,
      eventCategory: eventCategoryReducer,
    }),
    EffectsModule.forRoot([
      NavigationEffects,
      BannerEffects,
      CampaignEffects,
      AffiliateEffects,
      CommissionGroupEffects,
      LanguageEffects,
      CountryEffects,
      PaymentEffects,
      UserEffects,
      CampaignAffiliatesEffects,
      DownlinesEffects,
      PaymentMethodEffects,
      PageEffects,
      ChannelEffects,
      DashboardEffects,
      ConfigEffects,
      TopListingEffects,
      AffiliateManagerssEffects,
      ReportEffects,
      MessagesEffects,
      CampaignUrlsEffects,
      NotificationsEffects,
      CategoryEffects,
      EventCategoryEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: "window", useValue: window, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
